import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Carousel3.css";
import tours from "../../API/tours"; // Import the tours data
import Loading from "../loading/Loading"; // Import Loading component

const Carousel3 = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Filter only the Private tours
  const privateTours = tours.filter((tour) => tour.typeOfTour === "Private");

  const handleNavigate = (name) => {
    setLoading(true);
    const formattedName = name.toLowerCase().replace(/\s+/g, "-"); // Format name to URL-friendly

    setTimeout(() => {
      navigate(`/tours/${formattedName}`);
      window.scrollTo(0, 0);
      setLoading(false);
    }, 1000); // Simulating a short delay for loading effect
  };

  return (
    <div className="carousel3MainContainer">
      {loading && <Loading />} {/* Show loading spinner when navigating */}
      <section className="carousel3-section">
        <h2>Private Tour</h2>
        <p>
          Enjoy a private tour designed just for you! Whether you're traveling
          with family, friends, or your partner, experience a personalized
          adventure tailored to your interests.
        </p>
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          navigation
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {privateTours.map((tour) => (
            <SwiperSlide key={tour.id}>
              <div
                className="carousel3-item"
                onClick={() => handleNavigate(tour.name)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={tour.imgArray[0]} // Use the first image from imgArray
                  alt={tour.name}
                  className="carousel3-img"
                  loading="lazy"
                />
                <div className="carousel3-text">
                  <div className="carousel3-top">
                    <h3>{tour.name}</h3>
                    <span className="carousel3-price">₱{tour.basePrice}</span>
                  </div>
                  <span className="carousel3-rating">⭐ {tour.rating}</span>
                  <p>{tour.desc}</p>
                  <div className="carousel3-botDesc">
                    <span>{tour.typeOfTour} Tour</span>
                    <span>{tour.days}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
};

export default Carousel3;
